import{ButtonType as o}from"wix-rich-content-common";const t=o;export{t as BUTTONS};
//# sourceMappingURL=keys.js.map
